<template>
  <v-card
    class="mx-auto pa-4 mb-8 elevation-1"
    border
  >
    <v-card-title v-if='title.length' class="text-h5 font-weight-bold">
      {{ title }}
    </v-card-title>

    <v-list-item>
      <slot />
    </v-list-item>
  </v-card>
</template>

<script>
  export default {
    name: 'EnableCommunication',
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style scoped>

</style>
